import providerModuleGetters from "./providerModule/getters";

export default {
  ...providerModuleGetters,
};
